export const environment = { 
  production: false, 
  url_audaces_id: 'https://login-dev.audaces.com/core', 
  audaces_id_key: 'jira_form', 
  callback_url: 'https://insights-dev.audaces.com/',
  api_endpoint: 'https://insights-api-development.azurewebsites.net/issue',
  api_token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImRldiIsIm5hbWUiOiJEZXNlbnZvbHZpbWVudG8iLCJ2YWxpZCI6MSwiaWF0IjoxNjk2NTk5NDMwfQ.ak4maMZyxvpJPQ_Z4stVjodr8vemOCEICx1eluaJlqI' 
};
